import StarHalfFilledIconPath from "@ingka/ssr-icon/paths/star-half-filled";

export default StarHalfFilledIconPath;
